module.exports = __webpack_public_path__ + "static/img/SmileAnimation_whitepeachginger.cea2b65.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_whitepeachginger.gif
// module id = 90Kr
// module chunks = 0